export default __webpack_public_path__ + "static/media/Scheduled_badge.74873ec5.svg";